
$(function () {
    $('#page-button').on('click', function () {
        location.href = '?page=' + $('#page-input').val();
    });
});
